(function () {
  const articleContent = document.querySelector('.article__content');

  if (!articleContent) return;

  /* 見出しサイズ取得 */

  function setHeadingSizeVariables() {
    function getHeadingStyle(tagName) {
      const sample = document.createElement(tagName);

      sample.textContent = 'Sample Heading';

      sample.style.position = 'absolute';
      sample.style.visibility = 'hidden';
      sample.style.pointerEvents = 'none';
      sample.style.width = 'auto';
      sample.style.height = 'auto';

      articleContent.appendChild(sample);

      const style = window.getComputedStyle(sample);

      const result = {
        fontSize: style.fontSize,
        lineHeight: style.lineHeight
      };

      sample.remove();

      return result;
    }

    const h1Style = getHeadingStyle('h2');
    const h2Style = getHeadingStyle('h3');

    articleContent.style.setProperty(
      '--article-h1-font-size',
      h1Style.fontSize
    );

    articleContent.style.setProperty(
      '--article-h1-line-height',
      h1Style.lineHeight
    );

    articleContent.style.setProperty(
      '--article-h2-font-size',
      h2Style.fontSize
    );

    articleContent.style.setProperty(
      '--article-h2-line-height',
      h2Style.lineHeight
    );
  }

  setHeadingSizeVariables();

  /* スライド制御 */

  function createCarouselFromImageGroup(images) {
    if (images.length < 2) return;

    const carousel = document.createElement('div');
    carousel.className = 'blog-carousel';

    const viewport = document.createElement('div');
    viewport.className = 'blog-carousel__viewport';

    const track = document.createElement('div');
    track.className = 'blog-carousel__track';

    const prevBtn = document.createElement('button');
    prevBtn.className = 'blog-carousel__arrow blog-carousel__prev';
    prevBtn.type = 'button';
    prevBtn.innerHTML = '‹';

    const nextBtn = document.createElement('button');
    nextBtn.className = 'blog-carousel__arrow blog-carousel__next';
    nextBtn.type = 'button';
    nextBtn.innerHTML = '›';

    const dotsWrap = document.createElement('div');
    dotsWrap.className = 'blog-carousel__nav';

    images.forEach(function (img, index) {
      const slide = document.createElement('div');
      slide.className = 'blog-carousel__slide';

      slide.appendChild(img.cloneNode(true));
      track.appendChild(slide);

      const dot = document.createElement('button');
      dot.className = 'blog-carousel__dot';
      dot.type = 'button';
      dot.dataset.index = index;

      if (index === 0) {
        dot.classList.add('is-active');
      }

      dotsWrap.appendChild(dot);
    });

    viewport.appendChild(track);
    viewport.appendChild(prevBtn);
    viewport.appendChild(nextBtn);

    carousel.appendChild(viewport);
    carousel.appendChild(dotsWrap);

    images[0].before(carousel);

    images.forEach(function (img) {
      img.remove();
    });

    initCarousel(carousel);
  }

  function initCarousel(carousel) {
    const track = carousel.querySelector('.blog-carousel__track');
    const slides = carousel.querySelectorAll('.blog-carousel__slide');
    const dots = carousel.querySelectorAll('.blog-carousel__dot');
    const prevBtn = carousel.querySelector('.blog-carousel__prev');
    const nextBtn = carousel.querySelector('.blog-carousel__next');

    let currentIndex = 0;
    let startX = 0;
    let endX = 0;

    function getSlideDistance() {
      const slideWidth = slides[0].offsetWidth;
      const gap = parseFloat(window.getComputedStyle(track).gap) || 0;
      return slideWidth + gap;
    }

    function updateCarousel() {
      const distance = getSlideDistance();

      track.style.transform =
        'translateX(' + (-currentIndex * distance) + 'px)';

      dots.forEach(function (dot) {
        dot.classList.remove('is-active');
      });

      if (dots[currentIndex]) {
        dots[currentIndex].classList.add('is-active');
      }
    }

    function goNext() {
      currentIndex = (currentIndex + 1) % slides.length;
      updateCarousel();
    }

    function goPrev() {
      currentIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateCarousel();
    }

    nextBtn.addEventListener('click', goNext);
    prevBtn.addEventListener('click', goPrev);

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        currentIndex = Number(dot.dataset.index);
        updateCarousel();
      });
    });

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    });

    track.addEventListener('touchend', function (e) {
      endX = e.changedTouches[0].clientX;

      const diffX = startX - endX;

      if (Math.abs(diffX) > 50) {
        diffX > 0 ? goNext() : goPrev();
      }
    });

    window.addEventListener('resize', updateCarousel);

    updateCarousel();
  }

function processContainer(container) {
  let imageGroup = [];

  Array.from(container.childNodes).forEach(function (node) {
    if (
      node.nodeType === Node.TEXT_NODE &&
      node.textContent.trim() === ''
    ) {
      return;
    }

    if (
      node.nodeType === Node.ELEMENT_NODE &&
      node.tagName === 'IMG'
    ) {
      imageGroup.push(node);
    } else {
      if (imageGroup.length >= 2) {
        createCarouselFromImageGroup(imageGroup);
      }

      imageGroup = [];
    }
  });

  if (imageGroup.length >= 2) {
    createCarouselFromImageGroup(imageGroup);
  }
}

  processContainer(articleContent);

  const containers = articleContent.querySelectorAll('p, div');

  containers.forEach(function (container) {
    processContainer(container);
  });
})();

